export default __webpack_public_path__ + "static/media/ele_example_2_1.9d5b8c41.png";